import { ILicenseV2, IBulkTransitionResponse } from "../../../common/models/license.interface";
import { ILoadableWrapper, onLoadableLoad, onLoadableSuccess, toLoadableWrapper } from "../../../common/models";
import { replaceItem } from "../../../common/state/common";

export function addLicense(currentLicenses: ILoadableWrapper<ILicenseV2>[], newLicense: ILicenseV2): ILoadableWrapper<ILicenseV2>[] {
    if (newLicense == undefined || newLicense.id == undefined) {
        return currentLicenses;
    }

    return currentLicenses.concat(toLoadableWrapper(newLicense));
}

export function replaceLicense(currentLicenses: ILoadableWrapper<ILicenseV2>[], updatedLicense: ILicenseV2): ILoadableWrapper<ILicenseV2>[] {
    if (updatedLicense == undefined || updatedLicense.id == undefined) {
        return currentLicenses;
    }

    return replaceItem(currentLicenses, onLoadableSuccess(toLoadableWrapper(updatedLicense)));
}

export function setLicensesDeleting(currentLicenses: ILoadableWrapper<ILicenseV2>[], ids: string[]): ILoadableWrapper<ILicenseV2>[] {
    const idSet = new Set(ids);

    return currentLicenses.map(l => idSet.has(l.id) ? onLoadableLoad({ ...l }) : l);
}

export function removeLicenses(currentLicenses: ILoadableWrapper<ILicenseV2>[], removedLicenses: ILicenseV2[]): ILoadableWrapper<ILicenseV2>[] {
    const removedIds = new Set(removedLicenses.map(l => l.id));

    return currentLicenses.filter(l => !removedIds.has(l.id));
}

export function addLicenses(currentLicenses: ILoadableWrapper<ILicenseV2>[], newLicenses: ILicenseV2[]): ILoadableWrapper<ILicenseV2>[] {
    const validLicenses = newLicenses.filter(l => l != undefined && l.id != undefined);
    if (validLicenses.length === 0) {
        return currentLicenses;
    }

    return currentLicenses.concat(validLicenses.map(l => toLoadableWrapper(l)));
}

export function applyTransitionResults(
    currentLicenses: ILoadableWrapper<ILicenseV2>[],
    response: IBulkTransitionResponse
): ILoadableWrapper<ILicenseV2>[] {
    const updatedMap = new Map<string, ILicenseV2>();
    for (const result of response.results) {
        if (result.status === 'success' && result.data) {
            updatedMap.set(result.licenseId, result.data);
        }
    }

    if (updatedMap.size === 0) {
        return currentLicenses;
    }

    return currentLicenses.map(l => {
        const updated = updatedMap.get(l.id);
        return updated ? onLoadableSuccess(toLoadableWrapper(updated)) : l;
    });
}

export function setLicensesLoading(
    currentLicenses: ILoadableWrapper<ILicenseV2>[],
    ids: string[]
): ILoadableWrapper<ILicenseV2>[] {
    const idSet = new Set(ids);
    return currentLicenses.map(l => idSet.has(l.id) ? onLoadableLoad({ ...l }) : l);
}

export function revertLicensesLoading(
    currentLicenses: ILoadableWrapper<ILicenseV2>[]
): ILoadableWrapper<ILicenseV2>[] {
    return currentLicenses.map(l => l.loading ? onLoadableSuccess({ ...l }) : l);
}

export function clearLicenses(): ILoadableWrapper<ILicenseV2>[] {
    return [];
}
